import React from "react";
import { useParams } from "react-router";
import LeftNavTeamTab from "../../../../components/Tab/LeftNavTeamTab";
import LeftNavProjectTab from "../../../../components/Tab/LeftNavProjectTab";

const TeamProject = (props) => {
  const { projects, teamUrl, url } = props;
  const { projectId } = useParams();

  return (
    <React.Fragment>
      <LeftNavTeamTab {...props} url={teamUrl} />
      {projects.map((project) => (
        <LeftNavProjectTab
          active={projectId === project.id}
          label={project.name}
          url={url(project.id)}
          key={project.id}
        />
      ))}
    </React.Fragment>
  );
};

export default TeamProject;
